"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Location = void 0;
var utils_1 = require("../../utils");
var location_card_1 = require("../../components/entities/location-card");
var location_details_layout_1 = require("../../components/entities/location-details-layout");
var open_graph_cell_1 = require("../../components/entities/open-graph-cell");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
var graphql_1 = require("../../utils/graphql");
var ITEMS_PER_PAGE = 9;
exports.Location = {
  name: 'Location',
  slug: 'city',
  groupName: 'Places',
  label: 'City',
  pluralLabel: 'Cities',
  usePublishStatus: true,
  useDuplicateCheck: true,
  useConversation: true,
  includeInSearch: true,
  useFollowers: true,
  // useNetwork: true,
  useSlices: true,
  useSpaces: true,
  useVisibility: true,
  useMap: true,
  usePermissions: true,
  canEmbed: true,
  useModerators: true,
  useConnections: true,
  platformActivity: {
    tab: 'own'
  },
  autoRoutes: ['create', 'update', 'list', 'details'],
  select: {
    canCreate: function (_a) {
      var currentUserCan = _a.currentUserCan;
      return currentUserCan(['write:any', 'create:locations']);
    },
    maxWidth: '800px',
    transform: function (entity, context) {
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        label: "".concat(entity.name).concat(entity.country ? " - ".concat(entity.country.shorthand || entity.country.name) : '')
      });
    },
    queryFields: "\n      country { id name slug shorthand }\n    "
  },
  banner: {
    showDescription: false
  },
  components: {
    card: location_card_1.LocationCard,
    details: location_details_layout_1.LocationDetailsLayout,
    cell: open_graph_cell_1.OpenGraphCell
  },
  create: {
    label: 'Add %s'
  },
  form: {
    queryFields: "",
    paginate: true,
    modal: {
      maxWidth: "1200px",
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'stats'
    }, {
      name: 'library'
    }, {
      name: 'activity'
    }, {
      name: 'data'
    }],
    fields: __assign(__assign({}, utils_1.entityStandardFormFields), {
      banner: {
        type: 'banner',
        fieldSet: 'overview'
      },
      country: {
        type: 'linked',
        entityTypeName: 'Economy'
      },
      state: {
        type: 'linked',
        entityTypeName: 'State'
      },
      description: {
        type: 'description',
        useCompletions: true
      },
      latitude: {
        type: 'float',
        maxWidth: '400px',
        description: 'What is the Latitude of this {{LOCATION}}, in decimal degrees notation?'
      },
      longitude: {
        type: 'float',
        maxWidth: '400px',
        description: 'What is the Longitude of this {{LOCATION}}, in decimal degrees notation?'
      },
      files: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset'
      },
      areaInSquareKm: {
        type: 'float',
        maxWidth: '300px',
        fieldSet: 'stats',
        description: 'What is the area of this {{LOCATION}} in square kilometres?'
      },
      densityPerSquareKm: {
        type: 'float',
        maxWidth: '300px',
        fieldSet: 'stats',
        description: 'What is the density (number of people) of this {{LOCATION}} per square kilometre?'
      },
      population: {
        type: 'float',
        maxWidth: '300px',
        fieldSet: 'stats',
        description: 'What is the current (actual or estimated) population of this {{LOCATION}}?'
      },
      populationFemale: {
        type: 'float',
        maxWidth: '300px',
        fieldSet: 'stats',
        label: 'Population (Female)',
        description: 'What is the current female population (actual or estimated) of this {{LOCATION}}?'
      },
      populationMale: {
        type: 'float',
        maxWidth: '300px',
        fieldSet: 'stats',
        label: 'Population (Male)',
        description: 'What is the current male population (actual or estimated) of this {{LOCATION}}?'
      },
      populationCity: {
        type: 'float',
        maxWidth: '300px',
        fieldSet: 'stats',
        label: 'Population (Metro Area)',
        description: 'What is the population of just the metro area of this {{LOCATION}}?'
      },
      medianAge: {
        type: 'float',
        maxWidth: '100px',
        fieldSet: 'stats',
        description: 'What is the median age of this {{LOCATION}} in years?'
      },
      age0To19: {
        type: 'float',
        maxWidth: '100px',
        fieldSet: 'stats',
        label: 'Percentage of People Aged 0-19'
      },
      age20To49: {
        type: 'float',
        maxWidth: '100px',
        fieldSet: 'stats',
        label: 'Percentage of People Aged 20-49'
      },
      age50Plus: {
        type: 'float',
        maxWidth: '100px',
        fieldSet: 'stats',
        label: 'Percentage of People Aged 50+'
      },
      gdp: {
        type: 'float',
        maxWidth: '200px',
        fieldSet: 'stats',
        label: 'GDP (USD)',
        description: 'What is the Gross Domestic Product (GDP) of this {{LOCATION}}, in US Dollars (USD)?'
      },
      perCapitaIncome: {
        type: 'float',
        maxWidth: '200px',
        fieldSet: 'stats',
        label: 'Per Capita Income (USD)',
        description: 'What is the income per capita (per person) in US Dollars (USD) in this {{LOCATION}}?'
      },
      medianHouseholdIncome: {
        type: 'float',
        maxWidth: '200px',
        fieldSet: 'stats',
        label: 'Median Household Income (USD)',
        description: 'What is the Median Household Income in US Dollars (USD) in this {{LOCATION}}?'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      quotes: {
        type: 'linkedMultiple',
        entityTypeName: 'Quote',
        fieldSet: 'library'
      },
      impactResults: {
        type: 'linkedTable',
        entityTypeName: 'ImpactResult',
        fieldSet: 'activity',
        description: 'Describe the latest results and achievements in this {{LOCATION}}'
      },
      indicatorResults: {
        type: 'linkedTable',
        entityTypeName: 'IndicatorResult',
        fieldSet: 'data'
      }
    })
  },
  filters: {
    fields: {
      country: {
        entityTypeName: 'Economy'
      },
      state: {
        entityTypeName: 'State'
      }
    }
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      latitude longitude\n      people { name }\n      feedEntries { name url }\n\n      challenges { name }\n      keyIssues { name }\n      trends { name }\n      topics { name }\n      subTopics { name }\n\n      state { name }\n      country { name }\n    "], ["\n      latitude longitude\n      people { name }\n      feedEntries { name url }\n\n      challenges { name }\n      keyIssues { name }\n      trends { name }\n      topics { name }\n      subTopics { name }\n\n      state { name }\n      country { name }\n    "])))
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ...EntityValueFields\n      description { id text textTruncated: text(truncate: { words: 80 }) }\n      population populationMale populationFemale populationCity areaInSquareKm densityPerSquareKm\n      medianAge age0To19 age20To49 age50Plus gdp perCapitaIncome medianHouseholdIncome\n      latitude longitude\n      people { ...EntityValueFields }\n      organisations { ...EntityValueFields }\n      banner { ...EntityValueFields }\n      quotes { ...EntityValueFields person { ...EntityValueFields } }\n      feedEntries { ...EntityValueFields }\n      impactStories { ...EntityValueFields }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      impactResults {\n        ...EntityValueFields \n        title direction\n        type { ...EntityValueFields }\n      }\n      files { ...FileAssetValueFields }\n      state { ...EntityValueFields }\n      country { ...EntityValueFields }\n      links { ...EntityValueFields url }\n    "], ["\n      ...EntityValueFields\n      description { id text textTruncated: text(truncate: { words: 80 }) }\n      population populationMale populationFemale populationCity areaInSquareKm densityPerSquareKm\n      medianAge age0To19 age20To49 age50Plus gdp perCapitaIncome medianHouseholdIncome\n      latitude longitude\n      people { ...EntityValueFields }\n      organisations { ...EntityValueFields }\n      banner { ...EntityValueFields }\n      quotes { ...EntityValueFields person { ...EntityValueFields } }\n      feedEntries { ...EntityValueFields }\n      impactStories { ...EntityValueFields }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      impactResults {\n        ...EntityValueFields \n        title direction\n        type { ...EntityValueFields }\n      }\n      files { ...FileAssetValueFields }\n      state { ...EntityValueFields }\n      country { ...EntityValueFields }\n      links { ...EntityValueFields url }\n    "])))
  },
  list: {
    applyVisibilityState: true,
    banner: {
      content: 'Explore {{LOCATIONS}} and their approach to society'
    },
    hasSearch: true,
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      description { id plain(truncate: { words: 45 }) }\n      latitude\n      longitude\n      population\n      populationMale\n      populationFemale\n      populationCity\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      state { id name slug abbr }\n      country { id slug name _optionLabel iso shorthand openGraph { id image { id url } } }\n      organisations { id }\n      feedEntries { id }\n      people { id }\n    "], ["\n      description { id plain(truncate: { words: 45 }) }\n      latitude\n      longitude\n      population\n      populationMale\n      populationFemale\n      populationCity\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      state { id name slug abbr }\n      country { id slug name _optionLabel iso shorthand openGraph { id image { id url } } }\n      organisations { id }\n      feedEntries { id }\n      people { id }\n    "]))),
    baseState: {
      filter: {
        isPublished: {
          is: true
        }
      },
      limit: ITEMS_PER_PAGE
    }
  }
};
var templateObject_1, templateObject_2, templateObject_3;